import React, {useState, useRef} from "react";
import BaseModal from "../../modals/base-modal";
import FormField from "../../forms/form-field";
import FormSelect from "../../forms/form-select";
import Tooltip from "../../tooltip/tooltip";

const SaleStepPayment = ({show, onClose, onBack, onNext, total = 0, loading, noneCustomer = false}) => {
    const formRef = useRef(null);
    const [formValues, setFormValues] = useState({
        payment_form: noneCustomer ? 20 : "",
        payment_method: "",
        entity: "",
        partial_value: "",
    });

    const handleChange = (e) => {
        const {name, value} = e.target;
        setFormValues((prev) => ({...prev, [name]: value}));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onNext({...formValues, total});
    };

    const formFields = [
        {
            Component: FormField,
            label: "Valor a pagar",
            name: "value_to_pay",
            type: "currency",
            value: total,
            readOnly: true,
            placeholder: `$ ${total.toLocaleString()}`,
        },
        {
            Component: FormSelect,
            label: "Forma de Pago",
            name: "payment_form",
            options: [
                {value: 10, label: "Parcial", disabled: noneCustomer },
                {value: 20, label: "Total"},
            ],
            placeholder: "Selecciona una opción",
            value: formValues.payment_form,
            onChange: handleChange,
            required: true,
            disabled: noneCustomer,
        },
        {
            Component: FormField,
            label: "Valor Parcial",
            name: "partial_value",
            type: noneCustomer ? "hidden" : formValues.payment_form === 10 ? "currency" : "hidden",
            placeholder: "Escribe un valor",
            value: formValues.partial_value,
            onChange: handleChange,
            required: !noneCustomer && formValues.payment_form === 10,
        },
        {
            Component: FormField,
            label: "Saldo pendiente",
            name: "remaining_balance",
            type: noneCustomer ? "hidden" : formValues.payment_form === 10 ? "currency" : "hidden",
            readOnly: true,
            value:
                formValues.payment_form === 10
                    ? Math.max(total - (Number(formValues.partial_value) || 0), 0)
                    : "",
            placeholder: "$ 0",
        },
        {
            Component: FormSelect,
            label: "Método de pago",
            name: "payment_method",
            options: [
                {value: 10, label: "Tarjeta de Crédito o Débito"},
                {value: 20, label: "Transferencia"},
                {value: 30, label: "Efectivo"},
                {value: 40, label: "No registra"},
                {value: 50, label: "Otros"},
            ],
            placeholder: "Selecciona una opción",
            onChange: handleChange,
            required: true,
            tooltip: "Selecciona cómo se realizará el pago: tarjeta, efectivo o transferencia bancaria."
        },
        {
            Component: FormField,
            label: "Entidad",
            name: "entity",
            type: "text",
            placeholder: "Escribe aquí",
            disabled: formValues.payment_method !== 50,
            required: formValues.payment_method === 50,
            value: formValues.entity,
            onChange: handleChange,
        },
    ];

    return (
        <BaseModal
            show={show}
            onClose={onClose}
            title="Finalización de venta"
            onSave={() => formRef.current?.requestSubmit()}
            saveText="Finalizar"
            size="lg"
            backable={true}
            onBack={onBack}
            disableSave={loading}
        >
            <form
                className="d-flex flex-column gap-2"
                ref={formRef}
                onSubmit={handleSubmit}
            >
                {formFields.map((field, index) => {
                    if (field.type === "hidden") return null;
                    const FieldComponent = field.Component;
                    const inputElement = (
                        <FieldComponent key={index} id={field.name} {...field} />
                    );

                    return field.tooltip ? (
                        <Tooltip
                            key={index}
                            title={field.label}
                            description={field.tooltip}
                            position="right"
                            variant="rich"
                        >
                            {inputElement}
                        </Tooltip>
                    ) : (
                        inputElement
                    );
                })}
            </form>
        </BaseModal>
    );
};

export default SaleStepPayment;
